module.exports = "/images/environment-badge.svg?46b6b9e9688a339f06abc7ba6ce08636";